/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {PublishShiftScheduleRequest} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'
import {PublishShiftScheduleResponse} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'


export const publishShiftSchedule = (request: PublishShiftScheduleRequest, options?: CashRequestOptions) => post<PublishShiftScheduleRequest, PublishShiftScheduleResponse>("/2.0/cash/publish-shift-schedule", request, {...options, rejectOnError: true })